import { mundipaggInstance } from '@payments-checkout/shared/helpers/index';
import {
  isValidLanguage
} from '@payments-checkout/shared/helpers/translations/messages.helper';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError, AxiosResponse } from 'axios';

type CountryResponse = Array<{
  code: string;
  name: string;
}>;

const getCountriesList = async (language?: string) => {
  language = language || 'pt';
  if (!isValidLanguage(language)) throw new Error('Language is invalid');

  const response = await mundipaggInstance.get<CountryResponse>(
    `/maps/v1.0/countries/${language}`
  );
  return response;
};

const useCountriesList = (language?:string) => {
  const query = useQuery<AxiosResponse<CountryResponse>, AxiosError>({
    queryKey: ['useCountriesList', language],
    queryFn: async () => getCountriesList(language),
    staleTime: Infinity,
    gcTime: Infinity
  });

  return { ...query, data: query.data?.data };
};

export { getCountriesList, useCountriesList };
